<template>
  <div 
    class="relative text-white shadow-md rounded-xl p-6 h-full group"
    :style="{ backgroundImage: 'linear-gradient(to bottom, #FED803, #D91C5E)' }"
  >
    <div class="absolute top-4 right-4 bg-white/20 p-2 rounded-lg transition-transform duration-300 ease-in-out group-hover:scale-110 group-hover:rotate-6">
      <!-- START: DEFINITIVE SVG FIX -->
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <!-- END: DEFINITIVE SVG FIX -->
    </div>
    <h2 class="text-xl font-semibold border-b border-white/20 pb-4">Recording Schedule</h2>
    <div class="mt-4">
      <v-calendar 
        :attributes="attributes"
        is-expanded
        title-position="left"
        color="purple"
      >
        <template #day-popover="{ attributes }">
          <div class="p-2 text-gray-800 text-sm w-full max-w-xs">
            <h3 class="font-bold text-gray-900 mb-2 border-b">Scheduled Recordings</h3>
            <div class="space-y-1">
              <div
                v-for="attr in attributes"
                :key="attr.key"
                class="p-2 rounded-md hover:bg-purple-100 cursor-pointer transition-colors duration-200"
                @click="navigateToSubmission(attr.key)"
              >
                <p class="font-semibold">{{ attr.customData.guestName }}</p>
                <p v-if="attr.customData.hostName" class="text-xs text-gray-600">
                  <span class="font-medium">Host:</span> {{ attr.customData.hostName }}
                </p>
                <p class="text-xs">{{ formatTime(attr.customData.recordingDate) }}</p>
              </div>
            </div>
          </div>
        </template>
      </v-calendar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarPanel',
  props: {
    submissions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    attributes() {
      if (!this.submissions) return [];
      return this.submissions.map(submission => ({
        key: submission.id,
        highlight: {
          class: 'vc-highlight-bg-purple-dark',
        },
        dates: submission.recordingDate.toDate(),
        popover: true,
        customData: submission,
      }));
    }
  },
  methods: {
    formatTime(timestamp) {
      if (!timestamp?.toDate) return '';
      const date = timestamp.toDate();
      const options = { hour: 'numeric', minute: '2-digit', hour12: true };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
    navigateToSubmission(submissionId) {
      this.$router.push(`/submission/${submissionId}`);
    },
  },
}
</script>

<style>
.vc-highlight-bg-purple-dark {
  background-color: #190E4A !important;
}
.vc-container { width: 100% !important; }
.vc-pane { background: transparent !important; }
.vc-container { background: transparent !important; border: none !important; }
.vc-header { padding: 0 0 1rem 0 !important; }
.vc-title, .vc-arrow { color: #ffffff !important; }
.vc-weekday { color: #ffffff !important; opacity: 0.8; }
.vc-day-content { color: #ffffff !important; }
</style>